
import React from 'react';
import {
  Box,
  Heading,
} from '@chakra-ui/react';
import { useUser } from '@clerk/clerk-react';
import UsersList from './components/UsersList';
import AdminNavbar from '../../../components/navbars/adminNavbar/adminNavbar';

const AdminPage = () => {
  const { user, isLoaded, isSignedIn } = useUser();

  return (
    <Box p={6}>
      <AdminNavbar />
      {isLoaded && isSignedIn && user?.id && (
        <Box> 
    <Heading mb={4}>Admin Dashboard</Heading>
      <UsersList
      />
      </Box>
    )}
    </Box>
  );
};

export default AdminPage;
